import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import { pluralizeNights, _T } from 'appI18n';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import Carousel from 'react-components/Carousel';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { formatMoney } from 'utils';
import { toLocationHref } from '../../link-utils';
import AccomodationTab from '../AccomodationTab';
import AccomodationTabs from '../AccomodationTabs';
import AccomodationVariantList from '../AccomodationVariantList';
import TourVariantSelector from '../TourVariantSelector';
import { useStyles } from './styles';
import TourSummary from './TourSummary';
function getHotelGroupId(accmmd) {
    return accmmd.hotelId ? `${accmmd.hotelId}` : [
        accmmd.countryName,
        accmmd.cityName,
        accmmd.hotelName,
    ].join('|');
}
function getSortedAccomodations(accomodations) {
    return (accomodations !== null && accomodations !== void 0 ? accomodations : [])
        .slice()
        .sort((p1, p2) => p1.checkInDate > p2.checkInDate ? 1 : p1.checkInDate < p2.checkInDate ? -1 : 0);
}
function getCheapestHotelGroupItem(group) {
    return group.items
        .slice()
        .sort((a, b) => a.priceItem.price - b.priceItem.price)[0];
}
function formatUnique(values) {
    return values.filter((value, index, array) => !!value && array.indexOf(value) === index).join(', ');
}
function getHotelGroupItemKey(item) {
    var _a;
    const accmdIds = item.priceItem.accomodationVariants
        .map(v => v.id)
        .slice()
        .sort()
        .join('|');
    return [
        item.tour.id,
        item.tourVariant.id,
        (_a = item.priceItem.priceItem.servicesHash) !== null && _a !== void 0 ? _a : '',
        accmdIds,
    ].join('|');
}
function getHotelGroupDetailsItems(group, currentItem) {
    const currentItemKey = getHotelGroupItemKey(currentItem);
    return group.items.filter(item => getHotelGroupItemKey(item) !== currentItemKey);
}
function groupHotelGroupItemsByDate(items) {
    const groups = new Map();
    items.forEach(item => {
        var _a;
        const checkInDate = moment(item.tourVariant.checkInDate).format('YYYY-MM-DD');
        const duration = item.tourVariant.duration;
        const id = `${checkInDate}|${duration}`;
        const group = (_a = groups.get(id)) !== null && _a !== void 0 ? _a : {
            id,
            checkInDate,
            duration,
            minPrice: item.priceItem.price,
            currencyName: item.tour.currency.name,
            items: [],
        };
        group.minPrice = Math.min(group.minPrice, item.priceItem.price);
        group.items.push(item);
        groups.set(id, group);
    });
    return Array.from(groups.values())
        .map(group => (Object.assign(Object.assign({}, group), { items: group.items.slice().sort((a, b) => {
            const tourCompare = a.tour.name.localeCompare(b.tour.name);
            if (tourCompare !== 0)
                return tourCompare;
            return a.priceItem.price - b.priceItem.price;
        }) })))
        .sort((a, b) => {
        if (a.checkInDate !== b.checkInDate)
            return a.checkInDate < b.checkInDate ? -1 : 1;
        return a.duration === b.duration ? a.minPrice - b.minPrice : a.duration - b.duration;
    });
}
export function groupTourSearchResultsByHotel(items) {
    const groups = new Map();
    items.forEach(tour => {
        tour.variants.forEach(tourVariant => {
            tourVariant.priceVariants.forEach(priceItem => {
                const accomodationsByHotel = new Map();
                priceItem.accomodationVariants.forEach(accmmd => {
                    var _a;
                    const key = getHotelGroupId(accmmd);
                    const hotelAccomodations = (_a = accomodationsByHotel.get(key)) !== null && _a !== void 0 ? _a : [];
                    hotelAccomodations.push(accmmd);
                    accomodationsByHotel.set(key, hotelAccomodations);
                });
                accomodationsByHotel.forEach((accomodations, key) => {
                    var _a, _b, _c;
                    const first = accomodations[0];
                    const group = (_a = groups.get(key)) !== null && _a !== void 0 ? _a : {
                        id: key,
                        hotelId: first.hotelId,
                        hotelName: first.hotelName,
                        cityName: first.cityName,
                        countryName: first.countryName,
                        images: (_b = first.hotelImages) !== null && _b !== void 0 ? _b : [],
                        description: first.hotelDescription,
                        staticHotelUrl: first.staticHotelUrl,
                        items: [],
                    };
                    if (!group.images.length && ((_c = first.hotelImages) === null || _c === void 0 ? void 0 : _c.length))
                        group.images = first.hotelImages;
                    if (!group.description && first.hotelDescription)
                        group.description = first.hotelDescription;
                    if (!group.staticHotelUrl && first.staticHotelUrl)
                        group.staticHotelUrl = first.staticHotelUrl;
                    group.items.push({ tour, tourVariant, priceItem, accomodations });
                    groups.set(key, group);
                });
            });
        });
    });
    return Array.from(groups.values())
        .sort((a, b) => {
        var _a, _b, _c, _d;
        const aPrice = (_b = (_a = getCheapestHotelGroupItem(a)) === null || _a === void 0 ? void 0 : _a.priceItem.price) !== null && _b !== void 0 ? _b : Number.MAX_VALUE;
        const bPrice = (_d = (_c = getCheapestHotelGroupItem(b)) === null || _c === void 0 ? void 0 : _c.priceItem.price) !== null && _d !== void 0 ? _d : Number.MAX_VALUE;
        return aPrice === bPrice ? a.hotelName.localeCompare(b.hotelName) : aPrice - bPrice;
    });
}
function TourTitle({ title, type, url, href, forceDocumentNavigation }) {
    return (React.createElement(React.Fragment, null,
        type && React.createElement(Typography, { variant: "overline" }, type),
        React.createElement(Typography, { variant: "h5", gutterBottom: true }, forceDocumentNavigation
            ? React.createElement(Link, { href: href }, title)
            : React.createElement(Link, { component: RouterLink, to: url }, title))));
}
function TourLocation(props) {
    const location = props.accmmd
        ? [props.accmmd.countryName, props.accmmd.cityName, props.showHotelName === false ? undefined : props.accmmd.hotelName]
            .filter(Boolean)
            .join(', ')
        : undefined;
    return (React.createElement(React.Fragment, null,
        props.direction && React.createElement(Typography, { variant: "subtitle1" }, props.direction),
        props.accmmd &&
            React.createElement(Typography, { variant: "subtitle1", gutterBottom: true }, location)));
}
function TourDescription({ description }) {
    return (React.createElement("p", null, description));
}
function TourActions({ tourUrl, tourHref, tourVariant, priceItem, book, forceDocumentNavigation, classes }) {
    return (React.createElement("div", { className: classes.actionBox },
        React.createElement("div", { className: classes.priceBox },
            React.createElement(Typography, { variant: "overline", gutterBottom: true, className: classes.priceLabel }, _T.COMMON_PRICE_FROM),
            React.createElement(Typography, { variant: "h4", color: "primary", gutterBottom: true, className: classes.priceValue },
                formatMoney(priceItem.price, { currency: tourVariant.currency.name }),
                " ",
                tourVariant.currency.name)),
        React.createElement("div", { className: classes.actionButtons },
            forceDocumentNavigation
                ? React.createElement("a", { href: tourHref, className: classes.actionLink },
                    React.createElement(Button, { variant: "contained", color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null), fullWidth: true, className: classes.actionButton }, _T.COMMON_VIEW))
                : React.createElement(RouterLink, { to: tourUrl, className: classes.actionLink },
                    React.createElement(Button, { variant: "contained", color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null), fullWidth: true, className: classes.actionButton }, _T.COMMON_VIEW)),
            React.createElement(Box, { mt: 1 },
                React.createElement(Button, { variant: "contained", color: "primary", startIcon: React.createElement(ShoppingCartOutlinedIcon, null), onClick: book, fullWidth: true, className: classes.actionButton }, _T.COMMON_BUY)))));
}
function HotelGroupTourRow({ item, book, genUrl, classes, forceDocumentNavigation, showPeriod = true, }) {
    const theme = useTheme();
    const price = useMemo(() => item.priceItem.price, [item.priceItem.price]);
    const accmdIds = useMemo(() => item.priceItem.accomodationVariants.map(v => v.id), [item.priceItem.accomodationVariants]);
    const url = useMemo(() => genUrl(item.tourVariant.id, accmdIds, item.priceItem.priceItem.servicesHash, item.tour.name), [genUrl, item.tourVariant.id, accmdIds, item.priceItem.priceItem.servicesHash, item.tour.name]);
    const href = useMemo(() => toLocationHref(url), [url]);
    const allAvailable = item.accomodations.every(v => v.orderAvailability === "available");
    const roomText = formatUnique(item.accomodations.map(v => `${v.roomCategoryName}, ${v.roomTypeName}`));
    const mealText = formatUnique(item.accomodations.map(v => v.mealTypeName));
    const availability = allAvailable
        ? React.createElement(React.Fragment, null,
            React.createElement(CheckCircleOutlinedIcon, { style: { color: theme.palette.success.main, verticalAlign: 'middle' }, fontSize: "small" }),
            " ",
            _T.TOUR_AVAILABLE)
        : React.createElement(React.Fragment, null,
            React.createElement(ContactSupportOutlinedIcon, { style: { color: theme.palette.warning.main, verticalAlign: 'middle' }, fontSize: "small" }),
            " ",
            _T.TOUR_ONREQUEST);
    return (React.createElement(TableRow, null,
        React.createElement(TableCell, { className: classes.hotelGroupTourCol },
            React.createElement(Typography, { variant: "subtitle1" }, forceDocumentNavigation
                ? React.createElement(Link, { href: href }, item.tour.name)
                : React.createElement(Link, { component: RouterLink, to: url }, item.tour.name)),
            showPeriod ? (React.createElement(Typography, { variant: "subtitle2" },
                moment(item.tourVariant.checkInDate).format('L'),
                ", ",
                item.tourVariant.duration,
                " ",
                pluralizeNights(item.tourVariant.duration))) : null),
        React.createElement(TableCell, { className: classes.hotelGroupAccommodationCol }, roomText),
        React.createElement(TableCell, { className: classes.hotelGroupMealCol }, mealText),
        React.createElement(TableCell, { className: classes.hotelGroupAvailabilityCol }, availability),
        React.createElement(TableCell, { className: classes.hotelGroupPriceCol },
            formatMoney(price, { currency: item.tour.currency.name }),
            " ",
            item.tour.currency.name),
        React.createElement(TableCell, { className: classes.hotelGroupActionsCol },
            React.createElement(Box, { className: classes.hotelGroupActionBox },
                React.createElement(Button, { color: "primary", startIcon: React.createElement(ShoppingCartOutlinedIcon, null), className: classes.hotelGroupActionButton, onClick: () => book(item.tourVariant, item.priceItem.accomodationVariants, item.priceItem.priceItem.servicesHash) }, _T.COMMON_BUY),
                forceDocumentNavigation
                    ? React.createElement("a", { href: href, className: classes.hotelGroupActionLink },
                        React.createElement(Button, { color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null), className: classes.hotelGroupActionButton }, _T.COMMON_VIEW))
                    : React.createElement(RouterLink, { to: url, className: classes.hotelGroupActionLink },
                        React.createElement(Button, { color: "secondary", startIcon: React.createElement(VisibilityOutlinedIcon, null), className: classes.hotelGroupActionButton }, _T.COMMON_VIEW))))));
}
function HotelGroupTourList({ group, currentItem, book, genUrl, classes, forceDocumentNavigation, }) {
    const dateGroups = useMemo(() => groupHotelGroupItemsByDate(getHotelGroupDetailsItems(group, currentItem)), [group, currentItem]);
    const [currentGroupId, setCurrentGroupId] = useState(() => { var _a; return (_a = dateGroups[0]) === null || _a === void 0 ? void 0 : _a.id; });
    const currentGroup = useMemo(() => { var _a; return (_a = dateGroups.find(group => group.id === currentGroupId)) !== null && _a !== void 0 ? _a : dateGroups[0]; }, [dateGroups, currentGroupId]);
    const tableClasses = useMemo(() => ({
        hotelscol: classes.hotelGroupTourCol,
        accmdcol: classes.hotelGroupAccommodationCol,
        mealcol: classes.hotelGroupMealCol,
        availcol: classes.hotelGroupAvailabilityCol,
        pricecol: classes.hotelGroupPriceCol,
        actionscol: classes.hotelGroupActionsCol,
    }), [classes]);
    if (!currentGroup)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(AccomodationTabs, { value: currentGroup.id, onChange: (_event, value) => setCurrentGroupId(value) }, dateGroups.map(group => (React.createElement(AccomodationTab, { key: group.id, value: group.id, title: `${moment(group.checkInDate).format('L')}, ${group.duration} ${pluralizeNights(group.duration)}`, subtitle: `${_T.COMMON_FROM} ${formatMoney(group.minPrice, { currency: group.currencyName })} ${group.currencyName}` })))),
        React.createElement(AccomodationVariantList, { firstColumnTitle: _T.COMMON_TOUR, minWidth: 790, classes: tableClasses, availabilityBeforePrice: true }, currentGroup.items.map((item, index) => (React.createElement(HotelGroupTourRow, { key: `${item.tour.id}-${item.tourVariant.id}-${item.priceItem.priceItem.servicesHash}-${index}`, item: item, book: book, genUrl: genUrl, classes: classes, forceDocumentNavigation: forceDocumentNavigation, showPeriod: false }))))));
}
/**
 * Карточка с туром.
 */
function TourSearchResultCard(props) {
    var _a;
    const [isOpen, setIsOpen] = useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const viewModel = useMemo(() => {
        var _a, _b, _c;
        if (props.hotelGroup) {
            const cheapest = getCheapestHotelGroupItem(props.hotelGroup);
            if (!cheapest)
                return undefined;
            const detailsItems = getHotelGroupDetailsItems(props.hotelGroup, cheapest);
            return {
                sourceTour: cheapest.tour,
                images: ((_a = props.hotelGroup.images) === null || _a === void 0 ? void 0 : _a.length) ? props.hotelGroup.images : (_b = cheapest.tour.images) !== null && _b !== void 0 ? _b : [],
                title: props.hotelGroup.hotelName,
                type: _T.COMMON_HOTEL,
                direction: cheapest.tour.directionName,
                description: `${_T.COMMON_TOUR}: ${cheapest.tour.name}`,
                tourVariant: cheapest.tourVariant,
                priceItem: cheapest.priceItem,
                summaryAccomodations: getSortedAccomodations(cheapest.accomodations),
                showMoreTitle: _T.COMMON_MORE,
                tourNameForUrl: cheapest.tour.name,
                isHotelGroup: true,
                detailsAvailable: detailsItems.length > 0,
                hotelGroupCurrentItem: cheapest,
            };
        }
        const result = props.item.findCheapestTourVariant();
        if (!result)
            return undefined;
        const [cheapestVariant, cheapestPriceItem] = result;
        if (!cheapestPriceItem)
            return undefined;
        return {
            sourceTour: props.item,
            images: (_c = props.item.images) !== null && _c !== void 0 ? _c : [],
            title: props.item.name,
            type: props.item.typeName,
            direction: props.item.directionName,
            description: props.item.description,
            tourVariant: cheapestVariant,
            priceItem: cheapestPriceItem,
            summaryAccomodations: getSortedAccomodations(cheapestPriceItem.accomodationVariants),
            showMoreTitle: _T.TOUR_SHOW_MORE_DATES,
            tourNameForUrl: props.item.name,
            isHotelGroup: false,
            detailsAvailable: true,
        };
    }, [props.item, props.hotelGroup]);
    const cheapestVariant = viewModel === null || viewModel === void 0 ? void 0 : viewModel.tourVariant;
    const cheapestPriceItem = viewModel === null || viewModel === void 0 ? void 0 : viewModel.priceItem;
    const cheapestAccmdIds = useMemo(() => { var _a; return (_a = cheapestPriceItem === null || cheapestPriceItem === void 0 ? void 0 : cheapestPriceItem.accomodationVariants) === null || _a === void 0 ? void 0 : _a.map((x) => x.id); }, [cheapestPriceItem]);
    const tourUrl = useMemo(
    // TODO
    () => cheapestVariant && cheapestPriceItem
        ? props.genUrl(cheapestVariant.id, cheapestAccmdIds, cheapestPriceItem.priceItem.servicesHash, viewModel === null || viewModel === void 0 ? void 0 : viewModel.tourNameForUrl)
        : undefined, 
    //() => props.genUrl(cheapestVariant.id, cheapestVariant.accomodationPeriods.length > 1 ? cheapestVariant.accomodationPeriods.map(a => a.accomodationVariants[0].id) : cheapestAccmd?.id),
    [props.genUrl, cheapestVariant === null || cheapestVariant === void 0 ? void 0 : cheapestVariant.id, cheapestAccmdIds, cheapestPriceItem === null || cheapestPriceItem === void 0 ? void 0 : cheapestPriceItem.priceItem.servicesHash, viewModel === null || viewModel === void 0 ? void 0 : viewModel.tourNameForUrl]);
    const tourHref = useMemo(() => tourUrl ? toLocationHref(tourUrl) : '', [tourUrl]);
    const resolveImageUrl = (image) => {
        var _a, _b, _c, _d, _e, _f;
        if (isSmallScreen) {
            if (isXs)
                return (_b = (_a = image.urls.medium) !== null && _a !== void 0 ? _a : image.urls.large) !== null && _b !== void 0 ? _b : image.urls.thumbnail;
            return (_d = (_c = image.urls.large) !== null && _c !== void 0 ? _c : image.urls.medium) !== null && _d !== void 0 ? _d : image.urls.thumbnail;
        }
        return (_f = (_e = image.urls.thumbnail) !== null && _e !== void 0 ? _e : image.urls.medium) !== null && _f !== void 0 ? _f : image.urls.large;
    };
    if (!viewModel || !cheapestVariant || !cheapestPriceItem || !tourUrl)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Paper, { className: classes.root, classes: undefined, elevation: 2 },
            React.createElement("div", { className: classes.card },
                React.createElement("div", { className: classes.img }, viewModel.images.length > 1
                    ? (React.createElement(Carousel, { autoPlay: false, animation: "slide", fullHeightHover: true, navButtonsAlwaysVisible: true }, viewModel.images.map((x, i) => (props.forceDocumentNavigation
                        ? React.createElement("a", { href: tourHref, key: i },
                            React.createElement("img", { src: resolveImageUrl(x), loading: "lazy", alt: x.description, title: x.description, key: i }))
                        : React.createElement(RouterLink, { to: tourUrl, key: i },
                            React.createElement("img", { src: resolveImageUrl(x), loading: "lazy", alt: x.description, title: x.description, key: i })))))) : (props.forceDocumentNavigation
                    ? React.createElement("a", { href: tourHref }, viewModel.images.length == 1 ? (React.createElement("img", { src: resolveImageUrl(viewModel.images[0]), alt: viewModel.images[0].description })) : React.createElement(Box, { width: "100%", style: { minHeight: 275 } }))
                    : React.createElement(RouterLink, { to: tourUrl }, viewModel.images.length == 1 ? (React.createElement("img", { src: resolveImageUrl(viewModel.images[0]), alt: viewModel.images[0].description })) : React.createElement(Box, { width: "100%", style: { minHeight: 275 } })))),
                React.createElement(Grid, { container: true, className: classes.cardMain, spacing: 3 },
                    React.createElement(Grid, { item: true, xs: 12, md: 9 },
                        React.createElement(TourTitle, { title: viewModel.title, type: viewModel.type, url: tourUrl, href: tourHref, forceDocumentNavigation: props.forceDocumentNavigation }), (_a = viewModel.summaryAccomodations) === null || _a === void 0 ? void 0 :
                        _a.map((cheapestAccmd, i) => (React.createElement(React.Fragment, { key: cheapestAccmd.id },
                            React.createElement(TourLocation, { direction: viewModel.direction, accmmd: cheapestAccmd, showHotelName: !viewModel.isHotelGroup }),
                            viewModel.description ? React.createElement(TourDescription, { description: viewModel.description }) : null,
                            React.createElement(Box, { mb: 2, mt: 2 },
                                React.createElement(Divider, null)),
                            React.createElement(TourSummary, { tourDuration: cheapestAccmd.duration, tourStart: moment(cheapestAccmd.checkInDate).format('YYYY-MM-DD'), accmmd: cheapestAccmd }),
                            i < (viewModel.summaryAccomodations.length - 1) ?
                                React.createElement(Box, { mb: 2, mt: 2 },
                                    React.createElement(Divider, { variant: "inset" })) : null)))),
                    React.createElement(Grid, { item: true, xs: 12, md: 3, className: classes.cardActions },
                        React.createElement(Box, { flex: "1" },
                            React.createElement(TourActions, { tourUrl: tourUrl, tourHref: tourHref, tourVariant: cheapestVariant, priceItem: cheapestPriceItem, forceDocumentNavigation: props.forceDocumentNavigation, classes: classes, book: () => props.book(cheapestVariant, cheapestPriceItem.accomodationVariants, cheapestPriceItem.priceItem.servicesHash) })),
                        viewModel.detailsAvailable ? (React.createElement(Button, { size: "small", fullWidth: true, className: classes.showMoreButton, endIcon: !isOpen ? React.createElement(ExpandMore, { fontSize: "small" }) : React.createElement(ExpandLess, { fontSize: "small" }), onClick: () => setIsOpen((prev) => !prev) }, viewModel.showMoreTitle)) : null))),
            viewModel.detailsAvailable ? React.createElement(Collapse, { in: isOpen, mountOnEnter: true, unmountOnExit: true },
                React.createElement(Box, { className: classes.cardCollapse }, props.hotelGroup
                    ? React.createElement(HotelGroupTourList, { group: props.hotelGroup, currentItem: viewModel.hotelGroupCurrentItem, book: props.book, genUrl: props.genUrl, classes: classes, forceDocumentNavigation: props.forceDocumentNavigation })
                    : React.createElement(TourVariantSelector, { item: props.item, book: props.book, genUrl: props.genUrl, forceDocumentNavigation: props.forceDocumentNavigation }))) : null)));
}
export { TourSearchResultCard };
